import { render, staticRenderFns } from "./privacy-policy.vue?vue&type=template&id=96eef9f8&scoped=true&"
import script from "./privacy-policy.vue?vue&type=script&lang=js&"
export * from "./privacy-policy.vue?vue&type=script&lang=js&"
import style0 from "./privacy-policy.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./privacy-policy.vue?vue&type=style&index=1&id=96eef9f8&lang=scss&scoped=true&"
import style2 from "./privacy-policy.vue?vue&type=style&index=2&id=96eef9f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96eef9f8",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QSeparator,QOptionGroup,QTabs,QTab,QTabPanels,QTabPanel,QBtn,QSpinnerIos} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QSeparator,QOptionGroup,QTabs,QTab,QTabPanels,QTabPanel,QBtn,QSpinnerIos})
